export const NEWSLETTER_URL =
  "https://squareup.com/customer-programs/enroll/DUmVYjruANvU?utm_medium=copied-link&utm_source=online";
